export const AUTH_TOKEN_KEY = "authToken";
const LEGACY_AUTH_TOKEN_KEYS = ["tokenKey"];

const TOKEN_KEYS = [
  "token",
  "accessToken",
  "authToken",
  "jwt",
  "jwtToken",
  "idToken",
];

const AUTH_HEADER_KEYS = ["authorization", "x-auth-token", "x-access-token"];

const isLikelyAuthToken = (value) => {
  const token = value.trim();

  return (
    token.toLowerCase().startsWith("bearer ") ||
    /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(token) ||
    (token.length > 20 && !/\s/.test(token))
  );
};

const readTokenFromObject = (value) => {
  if (typeof value === "string" && isLikelyAuthToken(value)) {
    return value.trim();
  }

  if (!value || typeof value !== "object") {
    return "";
  }

  for (const key of TOKEN_KEYS) {
    if (typeof value[key] === "string" && value[key].trim()) {
      return value[key].trim();
    }
  }

  for (const key of ["data", "result", "user", "response"]) {
    const token = readTokenFromObject(value[key]);
    if (token) {
      return token;
    }
  }

  return "";
};

export const getStoredAuthToken = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  if (token) {
    return token;
  }

  for (const key of LEGACY_AUTH_TOKEN_KEYS) {
    const legacyToken = localStorage.getItem(key);

    if (legacyToken) {
      return legacyToken;
    }
  }

  return "";
};

export const clearStoredAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  LEGACY_AUTH_TOKEN_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const storeAuthToken = (token) => {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    LEGACY_AUTH_TOKEN_KEYS.forEach((key) => localStorage.removeItem(key));
  }
};

export const getAuthHeaders = () => {
  const token = getStoredAuthToken();

  if (!token) {
    return {};
  }

  return {
    Authorization: token.toLowerCase().startsWith("bearer ")
      ? token
      : `Bearer ${token}`,
  };
};

export const extractAuthToken = async (response) => {
  for (const headerKey of AUTH_HEADER_KEYS) {
    const headerValue = response.headers.get(headerKey);

    if (headerValue) {
      return headerValue.trim();
    }
  }

  const responseText = await response.text();

  if (!responseText) {
    return "";
  }

  try {
    const data = JSON.parse(responseText);
    return readTokenFromObject(data);
  } catch {
    return isLikelyAuthToken(responseText) ? responseText.trim() : "";
  }
};
